export const CLIENT_PORTFOLIO = [
  {
    id: 'c1',
    name: 'TechCorp Norway',
    industry: 'Teknologi',
    score: 68,
    trend: '+4',
    status: 'Active',
    riskLevel: 'Medium',
    nextAction: 'Oppfølgingsmøte 90-dagers plan',
    activeProject: 'Kulturtransformasjon 2024',
    lastAssessment: '12. Marts 2024'
  },
  {
    id: 'c2',
    name: 'Nordic Logistics',
    industry: 'Transport',
    score: 42,
    trend: '-12',
    status: 'Critical',
    riskLevel: 'High',
    nextAction: 'Krise-workshop: Stressmestring',
    activeProject: 'Arbeidsmiljø-rehabilitering',
    lastAssessment: '01. April 2024'
  },
  {
    id: 'c3',
    name: 'Oslo Kommune - Utdanning',
    industry: 'Offentlig',
    score: 82,
    trend: '+2',
    status: 'Stable',
    riskLevel: 'Low',
    nextAction: 'Kvartalsvis styreoppsummering',
    activeProject: 'Lederutvikling Program',
    lastAssessment: '20. Februar 2024'
  }
];